import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SKIPPED, getSyntheticsContext, willSyntheticsInjectRum, isSyntheticsTest } from '@datadog/browser-core';
export function startSyntheticsContext(hooks) {
  hooks.register(0 /* HookNames.Assemble */, function (_ref) {
    var eventType = _ref.eventType;
    if (!isSyntheticsTest()) {
      return SKIPPED;
    }
    return {
      type: eventType,
      session: {
        type: "synthetics" /* SessionType.SYNTHETICS */
      },
      synthetics: _objectSpread(_objectSpread({}, getSyntheticsContext()), {}, {
        injected: willSyntheticsInjectRum()
      })
    };
  });
}